<template>
  <dropdown 
    ref="dropdownRef" 
    :force-visibility="showDropdown" 
    class="workflow-job-picker" 
    title="Select job"
  >
    <div class="workflow-job-picker__label">
      <span>{{ selectedJobName }}</span>
      <i class="ddi ddi-caret-down" />
    </div>
    <template #content>
      <div>
        <ul>
          <li v-for="(job, index) in jobs" :key="index" @click="handleSelect(job.id)">
            <span :class="{ 'selected' : selectedJobId === job.id }">{{job.name}}</span>
          </li>
        </ul>
      </div>
    </template>
  </dropdown>
</template>

<script lang="ts">
/* General */
import { defineComponent } from 'vue'

/* Mixins */

/* Components */

/* Helpers */

/* Data types */
import { IWorkflowsInputModifyJobsJob } from '@/api/types/request.types'

/* API */

export default defineComponent({
  name: 'WorkflowJobPicker',

  props: {
    selectedJobId: {
      type: Number,
      default: null,
    },
    jobs: {
      type: Array as () => IWorkflowsInputModifyJobsJob[],
      default: null,
    },
  },

  emits: ['update:selectedJobId'],

  data() {
    return {
      showDropdown: false,
    }
  },

  computed: {
    internalSelectedJobID: {
      get(): number {
        return this.selectedJobId
      },
      set(newValue: number) {
        this.$emit('update:selectedJobId', newValue)
      },
    },
    selectedJobName(): string {
      const job = this.jobs.find(j => j.id === this.internalSelectedJobID)

      if (job) {
        return job.name
      }

      return 'No Job Selected!'
    },
  },

  methods: {
    handleSelect(jobID: number) {
      this.internalSelectedJobID = jobID
      this.showDropdown = true
      this.$nextTick(() => {
        this.showDropdown = false
      })
    },
  },
})
</script>

<style lang="scss">
.workflow-job-picker {
  background-color: var(--color-background-header);
  border-radius: 20px;
  border: $border--solid-light;
  width: 150px;
  padding: 4px 10px;

  &__label {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    span {
      @include single-line-ellipsis;
    }

    .ddi.ddi-caret-down {
      font-size: 12px;
    }
  }
}
</style>
